import { Component, OnInit } from '@angular/core';
import { AuthenticationNgRxActions } from '@geekbears/gb-ngrx-auth-basic';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-is-blocked',
  templateUrl: './is-blocked.page.html',
  styleUrls: ['./is-blocked.page.scss'],
})
export class IsBlockedComponent implements OnInit {
  constructor(private store$: Store) {}

  ngOnInit(): void {}
  logOut() {
    // localStorage.clear();

    localStorage.removeItem('s_admin');
    localStorage.removeItem('confirmAccountToken');
    localStorage.removeItem('confirmAccountEmail');
    this.store$.dispatch(AuthenticationNgRxActions.logout());
  }
}
